import React, { useEffect, useState } from "react";
import axios from "axios";
import { Trophy } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CoachPotwHistory = () => {
  const [history, setHistory] = useState([]);
  useEffect(() => {
    axios.get(`${API}/potw/history?limit=12`).then((r) => setHistory(r.data?.history || [])).catch(() => {});
  }, []);
  if (history.length === 0) return null;
  return (
    <div className="mb-8" data-testid="coach-potw-history">
      <div className="flex items-center gap-2 mb-4">
        <Trophy size={18} className="text-[#D4AF37]" />
        <h2 className="font-headings text-2xl uppercase tracking-wide">Player of the Week · Hall of Fame</h2>
      </div>
      <div className="bg-[#141414] border border-[#D4AF37]/25 rounded-lg divide-y divide-white/5">
        {history.map((h, i) => (
          <div key={h.week_key || i} className="flex items-center gap-3 px-4 py-3">
            <span className="w-7 h-7 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/40 flex items-center justify-center text-[11px] font-bold text-[#D4AF37]">{i + 1}</span>
            <span className="text-white font-semibold">{h.winner?.name}</span>
            <span className="text-white/40 text-sm">· {h.winner?.points} pts{h.winner?.streak ? ` · 🔥 ${h.winner.streak}d` : ""}</span>
            <span className="text-white/30 text-xs ml-auto">{h.week_of}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoachPotwHistory;
